import sbs from './sbs'

export default [sbs]
